"use client";

import { c as _c } from "react/compiler-runtime";
import { onMfaRequired } from "@opensea/embedded-wallet-sdk";
import { useEffect } from "react";
export const useOnMfaRequired = cb => {
  const $ = _c(3);
  let t0;
  if ($[0] !== cb) {
    t0 = () => {
      const unsub = onMfaRequired(cb);
      return unsub;
    };
    $[0] = cb;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(t0, t1);
};